/**
 * Checks if it is possible to mock the call to external social login options.
 * It uses an object defined in the browser console to update the state and redirect to
 * the choosen url using react router to prevent losing the app store.
 * Social logins mocked (add new ones in the list below):
 *  * SIWA / Apple
 *
 */
export const setSocialMocks = ({
    socialProvider,
    onSkipSocialLinks,
    skipSocialCalls,
} = {}) => {
    if (skipSocialCalls && onSkipSocialLinks) {
        // Execute the callback, must be an action that triggers the redux flow to update the store
        onSkipSocialLinks({ socialProvider });
    } else {
        return Promise.resolve();
    }
};
